import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';

import { DepositLayerDetailComponent } from '@connect-services/client/components/project-settings/deposit-layer-detail/deposit-layer-detail.component';
import { EditDepositLayerComponent } from '@connect-services/client/components/project-settings/edit-deposit-layer/edit-deposit-layer.component';
import { EditFluxLayerComponent } from '@connect-services/client/components/project-settings/edit-flux-layer/edit-flux-layer.component';
import { EditInterstandardLayerComponent } from '@connect-services/client/components/project-settings/edit-interstandard-layer/edit-interstandard-layer.component';
import { FluxLayerDetailComponent } from '@connect-services/client/components/project-settings/flux-layer-detail/flux-layer-detail.component';
import { InterstandardLayerDetailComponent } from '@connect-services/client/components/project-settings/interstandard-layer-detail/interstandard-layer-detail.component';
import { SymbologyEditComponent } from '@connect-services/client/components/project-settings/symbology-edit/symbology-edit.component';
import { Layer } from '@connect-services/client/sdk/api';
import { DetailPanelService } from '@connect-services/client/services/detail-panel.service';
import { LayerEditService } from '@connect-services/client/services/layer-edit.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        DepositLayerDetailComponent,
        EditDepositLayerComponent,
        EditInterstandardLayerComponent,
        EditFluxLayerComponent,
        FluxLayerDetailComponent,
        InterstandardLayerDetailComponent,
        SymbologyEditComponent,
    ],
    selector: 'app-project-settings-layer-detail-resolver',
    templateUrl: './project-settings-layer-detail-resolver.component.html',
})
export class ProjectSettingsLayerDetailResolverComponent {
    protected readonly detailPanelService = inject(DetailPanelService);
    protected readonly editLayerService = inject(LayerEditService);
    protected readonly Layer = Layer;

    private readonly destroyRef = inject(DestroyRef);

    public constructor() {
        this.destroyRef.onDestroy(() => {
            this.detailPanelService.activeLayerType.set(null);
        });
    }
}
